"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsDataContext = exports.AnalyticsDataProvider = void 0;
var _react = require("react");
const analyticsDataContext = exports.analyticsDataContext = /*#__PURE__*/(0, _react.createContext)({});
const {
  Provider: AnalyticsDataProvider
} = analyticsDataContext;
exports.AnalyticsDataProvider = AnalyticsDataProvider;
